<template>
  <span>
    <b>算法：</b>
    <a-button type="link" style="padding: 0 0 0 0" @click.prevent="algInfo"
      ><b>{{ aName }}</b></a-button
    >
    <a-button class="smallButton" v-show="show" type="primary" @click="toHelpPage"
      >算法文档</a-button
    >
    <a-button
      class="smallButton"
      v-show="show"
      type="primary"
      @click="trainNew()"
      >训练新实例</a-button
    >
  </span>
</template>

<script>
import util from '../util'
export default {
  props: ['aId', 'aName'],
  data() {
    return { show: false }
  },
  methods: {
    trainNew() {
      this.$router.push('/train/' + this.aId)
    },
    algInfo() {
      this.show = !this.show
    },
    toHelpPage() {
      util.toAlgHelp(this.aId, this.$router)
    }
  }
}
</script>

<style>
</style>
